import { Registry, } from '@oneaudi/sonic-feature-hub-tools';
export const I18NServiceV1Implementation = (options, env) => {
    const marketContextService = env.featureServices['audi-market-context-service'];
    const logger = env.featureServices['s2:logger'] ?? console;
    const locale = env.featureServices['locale-service'].language;
    const registry = Registry();
    const scopes = {};
    const urlLoaders = new Map();
    const combineWindowAndLoadedMessages = (loadedMessages) => {
        return {
            ...globalThis.i18n,
            ...loadedMessages,
        };
    };
    const fetchMessages = (url) => {
        logger.debug(`[audi-i18n-service] loading ${url}`);
        if (url) {
            let loader = urlLoaders.get(url);
            if (!loader) {
                logger.debug(`[audi-i18n-service] required to load url '${url}'`);
                loader = fetch(url)
                    .then((response) => {
                    if (response.status === 200) {
                        logger.debug(`[audi-i18n-service] successfully loaded ${url}`);
                        return response.json();
                    }
                    else {
                        throw new Error(`response status: ${response.status}`);
                    }
                })
                    .catch((err) => {
                    logger.error(`[audi-i18n-service] error loading ${url} - ${err.message}`);
                    return {};
                });
                urlLoaders.set(url, loader);
            }
            return loader;
        }
        return Promise.resolve({});
    };
    const setMessages = async () => {
        const messages = registry.getPayload();
        if (!messages?.[locale]) {
            const endpoint = marketContextService?.getContextItem('nemo.i18n.endpoint_url') ?? '';
            const fetchedMessages = await fetchMessages(options ? (options.i18nEndpointUrl ?? endpoint) : endpoint);
            const combinedMessages = combineWindowAndLoadedMessages(fetchedMessages);
            const registryData = {
                [locale]: combinedMessages,
            };
            if (!messages?.default) {
                registryData.default = combinedMessages;
            }
            registry.update(registryData);
        }
    };
    return {
        create: (consumerId) => {
            const subscription = registry.subscribe(consumerId);
            return {
                featureService: {
                    getMessages: registry.getPayload,
                    registerCallback: async (callback) => {
                        if (!subscription.isRegistered()) {
                            await setMessages();
                            subscription.register(callback);
                        }
                        else {
                            logger.warn(`audi-i18n-service: Callback is already registered for consumer ${consumerId}`);
                        }
                    },
                    setLocale: async () => {
                        await setMessages();
                    },
                    setScopes: (consumerScopes) => {
                        scopes[consumerId] = consumerScopes;
                    },
                },
                unbind: subscription.unregister,
            };
        },
    };
};
//# sourceMappingURL=i18n-service-v1.js.map